// app/src/modules/ui/BootLoader.tsx — the full-screen loader.
//
// Two things were wrong with what this replaces.
//
// 1. It painted `background: var(--ink)` on a div with `height: 100%`. When no
//    ancestor has a height that collapses, so the dark backdrop never covered
//    the viewport — and the loader renders the WHITE-ink logo, on the
//    assumption that it is sitting on something dark. On a light page you got a
//    white mark on a white background: an apparently empty screen while the app
//    booted. `position: fixed; inset: 0` cannot collapse.
//
// 2. It was a static logo. Altaf asked for the bike to ride in, and he is right
//    that it should: this is the screen people see every morning while the till
//    wakes up, and a mark that just sits there says nothing about whether
//    anything is happening.
//
// The animation is a scooter riding in from the left carrying the shop's flag,
// with the road moving under it. Everything is drawn in brand colours and the
// motion is honest — the wheels turn, the flag trails BEHIND the direction of
// travel, and the road moves the opposite way to the bike. Motion that
// contradicts itself reads as cheap even when nobody can say why.

import BrandLockup from "./Brand";

export default function BootLoader({ label = "Starting up…" }: { label?: string }) {
  return (
    <div className="boot" role="status" aria-live="polite">
      <div className="boot-stage">
        {/* The real mark rides in, rather than a scooter I draw myself.
            Two attempts at hand-drawing one produced a bicycle and then a
            blob — there is already a professional scooter illustration in
            /brand, it is theme-aware, and it is the shop's actual identity.
            The animation is mine; the artwork should not be. */}
        <div className="boot-rider">
          <BrandLockup size={124} className="boot-mark" />
          <span className="boot-speed" aria-hidden><i /><i /><i /></span>
        </div>

        <span className="boot-road" aria-hidden />
        <span className="boot-label">{label}</span>
      </div>
    </div>
  );
}
